// extracted by mini-css-extract-plugin
export default {"icon":"SetupDismantle_icon__zORHW"};